import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dateDiv"];

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const show = this.dateDivTarget.style.display === "block";
    this.dateDivTarget.style.display = !show ? "block" : "none";

    if (show && this.dateDivTarget.dataset.oldDate.length > 0) {
      window.location.href = this.dateDivTarget.dataset.link
    }
  }
}